import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProjectHolder } from '../../../interfaces/project-holder';
import { Project } from '../../../data/project/project';
import { ProjectService } from '../../../data/project/project.service';
import { filter, debounceTime, takeUntil } from 'rxjs/operators';
import { ProjectParticipant } from '../../../data/project/project-participant';
import { WsService } from '../../../../data/ws.service';
import { WsUpdateResponce } from '../../../../data/ws-update-responce';
import { Notification } from '../../../../notification/data/notification';
import { Subject, Subscription } from 'rxjs';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

@Component({
	selector: 'app-project-members',
	templateUrl: './project-members.component.html',
	styleUrls: ['./project-members.component.scss']
})
@RxJSUnsubscribe
export class ProjectMembersComponent implements OnInit, OnDestroy, RxJSUnsubscribable {
	projectId: number;
	participants: ProjectParticipant[];

  wsSub: Subscription;

	constructor(
		protected wsService: WsService,
		protected projectHolder: ProjectHolder,
		protected projectService: ProjectService
	) {
		this.projectId = this.projectHolder.project.id
		this.participants = this.projectHolder.project.participants
	}

	ngOnInit() {
		this.projectService.projectEmitter.update
			.pipe(
				filter(event => this.projectId === event.entityId),
				takeUntil(this.getUnsubFromAllSubs())
			)
			.subscribe(event => {
				this.participants = event.entity.participants
			})

    this.wsSub = this.wsService
			.listenUntilDestroyed<WsUpdateResponce<Project>>('/topic/update/model.project.Project', this)
			.pipe(
				filter(updateInfo => updateInfo.action === 'UPDATE'),
				filter(updateInfo => typeof updateInfo.entity !== 'undefined'),
				filter(updateInfo => typeof updateInfo.entity.participants !== 'undefined'),
				filter(updateInfo => updateInfo.entity.id === this.projectId),
				debounceTime(2000)
			)
			.subscribe(updateInfo => {
				this.projectHolder.project.participants = updateInfo.entity.participants
				this.participants = updateInfo.entity.participants
			})
	}

	ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
	}

	getUnsubFromAllSubs(): Subject<boolean> {
		return null
	}


}
